import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { GET_AUTHOR_POST_LOCATIONS } from '../../helpers/graphql/posts';
import ProfileTabs from './ProfileTabs';
import { GET_ITINERARIES } from '../../helpers/graphql/itineraries';
import graphQLClient from 'helpers/graphQLClient';

const Profile = props => {
  const [value, setValue] = React.useState(props.tabValue || 0);
  const [countryCodes, setCountryCodes] = React.useState(undefined);
  const [authorPostLocations, setAuthorPostLocations] = React.useState([]);

  const handleChange = newValue => {
    history.pushState(
      null,
      '',
      `/@${profile.author.username}${
        newValue === 1 ? '/map' : newValue === 2 ? '/itineraries' : ''
      }`,
    );
    setValue(newValue);
  };

  const { profile } = props;
  const author = profile.author.username;

  useEffect(() => {
    graphQLClient(GET_AUTHOR_POST_LOCATIONS, { author })
      .then(data => {
        if (data && data.posts && data.posts.length > 0) {
          setAuthorPostLocations(data.posts);
          const newCountryCodes = [];
          data.posts.forEach(d => {
            if (
              d.location &&
              d.location.countryCode &&
              newCountryCodes.indexOf(d.location.countryCode) === -1
            )
              newCountryCodes.push(d.location.countryCode);
          });
          setCountryCodes(newCountryCodes);
        } else setCountryCodes([]);
      })
      .catch(err => {
        console.log(err);
        setCountryCodes([]);
      });
  }, [author]);

  const userItineraries = useQuery(GET_ITINERARIES, {
    variables: { username: author },
  });

  const itineraries =
    userItineraries && userItineraries.data && userItineraries.data.itineraries;

  const tabs = [
    { label: 'Blog', index: 0 },
    { label: 'Map', index: 1 },
    ...(itineraries && itineraries.length > 0
      ? [{ label: 'Itineraries', index: 2 }]
      : []),
  ];

  return (
    <>
      {/* Tab bar */}
      <div className="tw-bg-[#FAF8F1] dark:tw-bg-[#0E1A16] tw-border-0 tw-border-b tw-border-solid tw-border-[#E7E0CF] dark:tw-border-[#26382F]">
        <div className="tw-mx-auto tw-max-w-5xl tw-px-4">
          <div className="tw-flex tw-items-center tw-gap-1">
            {tabs.map(tab => (
              <button
                key={tab.index}
                type="button"
                onClick={() => handleChange(tab.index)}
                className={`tw-border-0 tw-bg-transparent tw-cursor-pointer tw-px-4 tw-py-3.5 tw-text-sm tw-font-semibold tw-transition-colors tw-border-b-2 tw-border-solid ${
                  value === tab.index
                    ? 'tw-border-primary-600 tw-text-primary-700 dark:tw-text-primary-300 dark:tw-border-primary-400'
                    : 'tw-border-transparent tw-text-[#5F6F69] dark:tw-text-[#93A69E] hover:tw-text-[#1D2D28] dark:hover:tw-text-[#EBE6D9]'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Tab panels render immediately — only the Map tab waits for the
          post-locations query, everything else must not flash. */}
      <ProfileTabs
        isMini={props.isMini}
        itineraries={itineraries}
        profile={profile}
        value={value}
        countryCodes={countryCodes}
        userPosts={authorPostLocations}
      />
    </>
  );
};

Profile.propTypes = {
  author: PropTypes.string,
};

// eslint-disable-next-line import/no-unused-modules
export default Profile;
